import { Routes, Route } from 'react-router-dom';
import Navbar    from './components/Navbar';
import Footer    from './components/Footer';
import Home      from './pages/Home';
import Features  from './pages/Features';
import About     from './pages/About';
import Contact   from './pages/Contact';
import Partner   from './pages/Partner';
import DriverApp from './pages/DriverApp';
import Pricing   from './pages/Pricing';

export default function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/"          element={<Home />} />
        <Route path="/features"  element={<Features />} />
        <Route path="/about"     element={<About />} />
        <Route path="/contact"   element={<Contact />} />
        <Route path="/partner"   element={<Partner />} />
        <Route path="/driver-app" element={<DriverApp />} />
        <Route path="/pricing"    element={<Pricing />} />
      </Routes>
      <Footer />
    </>
  );
}
